import {delay} from '@vebox/etui-core';
import * as React from 'react';
import {JSONCensus} from "../../../processes/massive_actions/CensusCooler/data/models/JSONCensus";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {getFormattedDate} from "../../../ReadAndWrite/ReadAndWrite/utils";

declare var AppTranslations: AppTranslations;

interface ClosedLevelTabProps {
    lastVisitedCensus: JSONCensus
    stackManager: any
    updateOpenLevel: (open: boolean) => void;
}

export const ClosedLevelTab: React.FC<ClosedLevelTabProps> = ({lastVisitedCensus, stackManager, updateOpenLevel}) => {
    const goToCensusDetailLevel = () => {
        stackManager.goToLevel(2)
        delay(1500)
            .then(() => updateOpenLevel(true))
    }
    return (
        <>
            <div className="censusDetailClose">
                <div className="censusDetailCloseTab" onClick={goToCensusDetailLevel}>
                    <div
                        className="censusDetailCloseTabImg"
                    ></div>
                </div>
                <p className="censusDetailCloseTabTitle">
                    {`${AppTranslations.massiveActions.censusCooler.title} ${getFormattedDate(
                        {dateToFormat: lastVisitedCensus?.createdAt})}`}
                </p>
            </div>
        </>
    );
}